import { UpdateSmsTemplateMeta, UpdateSmsTemplatePayload } from 'types/store/UpdateSmsTemplate';
import { createAsyncReducer } from 'utils/Redux';

import { updateSmsTemplateActions } from '../actions';

export default createAsyncReducer<UpdateSmsTemplateMeta, UpdateSmsTemplatePayload>(updateSmsTemplateActions);
